import { Outlet, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { AppState, AuthProvider } from '../auth/AppAuth';

export const AuthenticationProviderWithNavigate = () => {
  const navigate = useNavigate();

  const onRedirectCallback = useCallback(
    (appState: AppState | undefined) => {
      navigate(appState?.returnTo || window.location.pathname);
    },
    [navigate],
  );

  return (
    <AuthProvider onRedirectCallback={onRedirectCallback}>
      <Outlet />
    </AuthProvider>
  );
};
